import { Component, signal } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ControlConfig } from '../../../models/api/reports/report';
import { ControlValueHandler } from '../../../utilities/control-value-handler';
import { PickListComponent } from '../../core/controls/pick-list.component';
import { PageHeaderComponent } from '../../core/labels/page-header.component';
import { BaseCriteriaComponent } from './base-criteria.component';

interface BankAccountCriteriaFormControls {
  bankAccountsSource?: FormControl<any[] | null>;
  bankAccounts?: FormControl<any[] | null>;
}

@Component({
  selector: 'app-bank-account-criteria',
  imports: [PageHeaderComponent, PickListComponent],
  template: `
    <app-page-header label="Bank account criteria" headerSize="h3" />
    @if (showBankAccounts()) {
      <app-pick-list
        [sourceControl]="fg.controls.bankAccountsSource"
        [targetControl]="fg.controls.bankAccounts"
        labelName="name"
        keyName="code"
        [showFilter]="true"
        [showTargetFilter]="true"
        [showSort]="true"
        [showMove]="true"
        [showAddRemoveAll]="true"
        [width]="850"
      />
    }
  `,
})
export class BankAccountCriteriaComponent extends BaseCriteriaComponent {
  showBankAccounts = signal(false);

  fg = new FormGroup<BankAccountCriteriaFormControls>({
    // Controls are created dynamically by control-configuration.service
  });

  protected readonly regionName = 'Bank Account Criteria';

  protected CONTROL_CONFIGS: ControlConfig[] = [
    {
      erfNames: 'BANK_ACCOUNTS',
      formControlName: 'bankAccounts',
      visibility: this.showBankAccounts,
      type: 'multiselect',
    },
  ];

  protected override loadControlConfiguration(config: ControlConfig): void {
    super.loadControlConfiguration(config);

    if (config.formControlName === 'bankAccounts' && config.controlRef) {
      const control = config.controlRef;

      const sourceControl = this.ensureFormControl<any[]>(
        'bankAccountsSource',
        [],
      );

      sourceControl.setValue(control.options);

      const userValue = control.defaultValue;
      if (userValue && userValue.trim().length > 0) {
        const codes = ControlValueHandler.parseMultiSelectValue(
          userValue,
          control.displayType === 'CHECKBOXLIST' ||
            control.displayType === 'MULTISELECTLISTBOX',
        );
        const selectedItems =
          control.options?.filter((opt) =>
            Array.isArray(codes)
              ? codes.includes(opt.code)
              : codes === opt.code,
          ) || [];
        this.fg.get('bankAccounts')?.setValue(selectedItems);
      } else {
        this.fg.get('bankAccounts')?.setValue([]);
      }
    }
  }

  protected override transformValueForSave(
    config: ControlConfig,
    value: any,
  ): any {
    if (
      config.controlRef?.erfName === 'BANK_ACCOUNTS' &&
      Array.isArray(value)
    ) {
      return value.map((item) => item.code);
    }
    return value;
  }
}
